import { render } from "./UserEdit.html?vue&type=template&id=080004e0&scoped=true&ts=true"
import script from "./UserEdit.ts?vue&type=script&lang=ts"
export * from "./UserEdit.ts?vue&type=script&lang=ts"

import "./UserEdit.css?vue&type=style&index=0&id=080004e0&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080004e0"]])

export default __exports__